var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBecomeCreator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5904_22198)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25.987C16 22.7948 20.1948 22 25.2035 22C30.1997 22 34.407 22.8209 34.407 26.013C34.407 29.2052 30.1997 30 25.2035 30C20.2073 30 16 29.1791 16 25.987Z",
    fill: "url(#paint0_linear_5904_22198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1625 19.525C16.7081 19.7873 16.1226 19.6332 15.9045 19.156C15.31 17.8549 15 16.4378 15 15C15 13.2446 15.4621 11.5202 16.3397 10C17.2174 8.47981 18.4798 7.21743 20 6.33975C21.5202 5.46206 23.2446 5 25 5C26.7554 5 28.4798 5.46206 30 6.33975C31.5202 7.21743 32.7826 8.47981 33.6603 10C34.5379 11.5202 35 13.2446 35 15C35 16.4378 34.69 17.8549 34.0955 19.156C33.8774 19.6332 33.2919 19.7873 32.8375 19.525C32.3832 19.2627 32.2332 18.6833 32.4405 18.2013C32.8743 17.1932 33.1 16.1041 33.1 15C33.1 13.5782 32.7257 12.1814 32.0148 10.95C31.3039 9.71864 30.2814 8.69612 29.05 7.98519C27.8186 7.27427 26.4218 6.9 25 6.9C23.5782 6.9 22.1814 7.27427 20.95 7.98519C19.7186 8.69612 18.6961 9.71864 17.9852 10.95C17.2743 12.1814 16.9 13.5782 16.9 15C16.9 16.1041 17.1257 17.1932 17.5595 18.2013C17.7668 18.6833 17.6168 19.2627 17.1625 19.525Z",
    fill: "#77C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5929 23.2878C13.1907 23.5799 12.6254 23.4921 12.3579 23.0732C11.0357 21.0028 10.2397 18.635 10.0462 16.1769C9.8292 13.4191 10.379 10.655 11.6349 8.19014C12.8908 5.72532 14.8038 3.6558 17.1625 2.2104C19.5212 0.764991 22.2337 -3.29882e-08 25 0C27.7663 3.29882e-08 30.4788 0.764991 32.8375 2.2104C35.1962 3.6558 37.1092 5.72532 38.3651 8.19014C39.621 10.655 40.1708 13.4191 39.9538 16.1769C39.7603 18.635 38.9643 21.0028 37.6421 23.0732C37.3746 23.4921 36.8093 23.5799 36.4071 23.2878C36.005 22.9956 35.9187 22.4343 36.1828 22.0132C37.3118 20.213 37.9919 18.1628 38.1593 16.0357C38.3503 13.6088 37.8665 11.1764 36.7613 9.00733C35.6561 6.83828 33.9726 5.01711 31.897 3.74515C29.8213 2.47319 27.4344 1.8 25 1.8C22.5656 1.8 20.1787 2.47319 18.103 3.74515C16.0274 5.01711 14.3439 6.83828 13.2387 9.00733C12.1335 11.1764 11.6497 13.6088 11.8407 16.0357C12.0081 18.1628 12.6882 20.213 13.8172 22.0132C14.0813 22.4343 13.995 22.9956 13.5929 23.2878Z",
    fill: "#77C0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 15,
    r: 5,
    fill: "url(#paint1_linear_5904_22198)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5904_22198",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5904_22198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5904_22198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5904_22198",
    x1: 37.0102,
    y1: 26.873,
    x2: 37.0102,
    y2: 20.0687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5904_22198",
    x1: 31.4142,
    y1: 18.6652,
    x2: 31.4142,
    y2: 15.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeCreator);
export default __webpack_public_path__ + "static/media/become_creator.7b682e348579b2698fcce560d6c33e31.svg";
export { ForwardRef as ReactComponent };